import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_QUOTATION,
  DELETE_QUOTATION,
  GET_QUOTATIONS,
  UPDATE_QUOTATION,
  UPDATE_QUOTATION_STATUS
} from "./actionTypes";

import {
  addQuotationFail,
  addQuotationSuccess,
  deleteQuotationFail,
  deleteQuotationSuccess,
  getQuotationsFail,
  getQuotationsSuccess,
  setState,
  updateQuotationFail,
  updateQuotationSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { quotations, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchQuotations({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, quotations, params.toString());
    yield put(setState(false));
    yield put(getQuotationsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getQuotationsFail(error));
  }
}

function* updateQuotation({ payload: quotationObj }) {
  try {
    const { id, recordStatus, ...rest } = quotationObj;
    yield call(patchApiCall, `${quotations}/${id}`, rest);
    const response = yield call(getTable, `${quotations}/${quotationObj.id}`);
    toast.success('Registro actualizado correctamente');
    yield put(updateQuotationSuccess(response));
  } catch (error) {
    yield put(updateQuotationFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateQuotationStatus({ payload: quotationObj }) {
  try {
    const { id } = quotationObj;
    yield call(patchApiCall, `${quotations}/${updateStatus}/${id}`, { recordStatus: quotationObj.recordStatus });
    const response = yield call(getTable, `${quotations}/${quotationObj.id}`);
    yield put(updateQuotationSuccess(response));
  } catch (error) {
    yield put(updateQuotationFail(error));
  }
}

function* deleteQuotation({ payload: quotationObj }) {
  try {
    yield call(deleteApiCall, `${quotations}/${quotationObj.id}`);
    yield put(deleteQuotationSuccess(quotationObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteQuotationFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingQuotation({ payload: quotation }) {
  try {
    const response = yield call(postApiCall, quotations, quotation);
    yield put(addQuotationSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addQuotationFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* quotationsSaga() {
  yield takeEvery(GET_QUOTATIONS, fetchQuotations);
  yield takeEvery(ADD_NEW_QUOTATION, postingQuotation);
  yield takeEvery(UPDATE_QUOTATION, updateQuotation);
  yield takeEvery(UPDATE_QUOTATION_STATUS, updateQuotationStatus);
  yield takeEvery(DELETE_QUOTATION, deleteQuotation);
}

export default quotationsSaga;
